export default __webpack_public_path__ + "static/media/basicStar.db397207.svg";